function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from "prop-types";

class WidgetTab extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "getStyle", () => {
      const _this$props = this.props,
            selected = _this$props.selected,
            theme = _this$props.theme;

      if (!selected) {
        return {};
      }

      return {
        borderColor: theme.primaryColor || "black"
      };
      let style = {};
    });
  }

  render() {
    const _this$props2 = this.props,
          selected = _this$props2.selected,
          onClick = _this$props2.onClick;
    const style = this.getStyle();
    return React.createElement("div", {
      className: "admin-widget__tab",
      style: style,
      "aria-selected": selected,
      onClick: onClick
    }, this.props.children);
  }

}

_defineProperty(WidgetTab, "defaultProps", {
  theme: {
    primaryColor: "black"
  },
  selected: false
});

WidgetTab.propTypes = process.env.NODE_ENV !== "production" ? {
  selected: PropTypes.bool
} : {};
export default WidgetTab;